import React, {useEffect, useState} from 'react'
import ProgramDashboardView from "../../views/ver_24.10/ProgramDashboard/ProgramDashboard.view";
import Icon1 from '../../assets/images/IconImg1.png';
import Icon2 from '../../assets/images/IconImg2.png';
import Icon3 from '../../assets/images/IconImg3.png';
import Icon4 from '../../assets/images/IconImg4.png';
import {useHistory, useParams} from 'react-router-dom';
import {LOCAL_STORAGE_KEYS, PBDQ3_PROGRAM_STATE} from "../../utils/constants";
import {fetchFingerprintService} from "../../services/public.service";


const STEPS = [
    {
        label: 'Program Overview',
        icon: Icon1,
        maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_DRAFT,
        stepIndex: 0,
        height:'40px',
        width:'70px',
    },
    {
        label: 'Your Program',
        icon: Icon2,
        maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED,
        stepIndex: 1,
        height:'45px',
        width:'55px',
    },
    {
        label: 'Your Program With',
        icon: Icon3,
        maximum_status: PBDQ3_PROGRAM_STATE.CONTENT_DRAFT,
        stepIndex: 2,
        height:'45px',
        width:'55px',
    },
    {
        label: 'Resources',
        icon: Icon4,
        maximum_status: PBDQ3_PROGRAM_STATE.PROGRAM_PUBLISHED,
        stepIndex: 3,
        height:'45px',
        width:'52px',
    },
];


function statusToStepConversion(status) {
    for (let stepIndex = 0; stepIndex < STEPS.length; stepIndex++) {
        if (status <= STEPS[stepIndex].maximum_status) {
            return stepIndex;
        }
    }
    return STEPS.length - 1;
}

const ProgramDashboardMainPage = () => {
    const history = useHistory();
    const [programStatus, setProgramStatus] = useState(null);
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        (async () => {
            const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
            if (fingerprint) {
                try {
                    const response = await fetchFingerprintService(fingerprint);
                    if(response.data) {
                        const fetchedStatus = response.data.existingProgram.program_state;
                        setProgramStatus(fetchedStatus);

                        const step = statusToStepConversion(fetchedStatus);
                        setActiveStep(step);
                    }
                } catch (error) {
                    console.error('Failed to fetch program status:', error);
                }
            }
        })();
    }, []);

    function cardsContent(stepIndex) {
        const contents = [
            'Overview of your curated program',
            'Preview your ready-to-go online program or edit it manually',
            'Your created program will automatically adjust its content and lessons based on the learner\'s current skill level or progress. The material is personalized in real-time to better suit each individual\'s needs.',
            'Everything you need to run your program online, offline, or integrate with your system via API',
        ];
        return contents[stepIndex] || '';
    }

    function cardsButtons(stepLabel, isEnabled) {
        switch (stepLabel) {
            case 'Program Overview':
                return [
                    {
                        label: 'View/Edit',
                        url: `/program-outline`,
                        stepCompletion: true,
                        enabled: isEnabled,
                    },
                ];
            case 'Your Program':
                return [
                    {
                        label: 'Preview',
                        url: `/welcome`,
                        enabled: isEnabled,
                    },
                    {
                        label: 'Subscribe to Edit',
                        url: `/subscribe`,
                        enabled: true,
                    },
                ];
            case 'Your Program With':
                return [
                    {
                        label: 'Enable',
                        url: `/welcome`,
                        enabled: isEnabled,
                    },
                    {
                        label: 'Preview',
                        url: `/welcome`,
                        enabled: isEnabled,
                    },
                ];
            case 'Resources':
                return [
                    {
                        label: 'Access',
                        url: `/welcome`,
                        enabled: isEnabled,
                    },
                ];
            default:
                return [];
        }
    }


    const cardsData = STEPS.map((step) => {

        const isCardEnabled = step.stepIndex <= activeStep;

        const buttons = cardsButtons(step.label, isCardEnabled);

        return {
            icon: step.icon,
            title: step.label,
            content: cardsContent(step.stepIndex),
            buttons: buttons,
            stepIndex: step.stepIndex,
            height: step.height,
            width: step.width,
        };
    });

    const data = {
        cardsData
    }
    const options = {
        activeStep,
    };
    const actions = {
        navigationAction: (url) => {
            history.push(url);
        },
        upgradeToProAction: () => {
            history.push('/subscribe');
        }
    };

    return (
        <div>
            <ProgramDashboardView
                data={data}
                options={options}
                actions={actions}
            />
        </div>
    );
};

export default ProgramDashboardMainPage;